import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'label-value-chips',
  templateUrl: './label-value-chips.component.html',
  styleUrls: ['./label-value-chips.component.css']
})
export class LabelValueChipsComponent implements OnInit {
  @Input() label: string;
  @Input() value: string;
  
  constructor() { }

  ngOnInit() {
  }

}
